import { Utility } from '../utility/utility_controller'

var intromedia_controller = {
	setSizes: function () {
		jQuery('#intro-region .mediawrap img').each(function () {
			var w = parseInt(jQuery(this).data('w'), 10)
			var h = parseInt(jQuery(this).data('h'), 10)
			var ar = (1.15 * w * window.innerHeight) / h / window.innerWidth
			ar = Math.round(Math.max(ar, 1.15) * 100)
			jQuery(this).attr('sizes', ar + 'vw')
		})
	},
	setSizingClassName: function () {
		jQuery('#intro-region .mediawrap img, #intro-region .mediawrap video').each(function () {
			var winAr = window.innerWidth / window.innerHeight
			var ar = parseInt(jQuery(this).data('w'), 10) / parseInt(jQuery(this).data('h'), 10)
			var sizeClass = winAr > ar ? 'w100' : 'h100'

			jQuery(this).removeClass('w100 h100').addClass(sizeClass)
		})
	},
	setW100H100Mediawrap: function () {
		var $portrait = jQuery('#intro-region .intro-portrait-media')
		var $landscape = jQuery('#intro-region .intro-landscape-media')

		if ($portrait.length > 0 && Utility.orientation === 'portrait') {
			if ($portrait.is('video')) {
				var portraitAr = $portrait.data('w') / $portrait.data('h')
				var portraitSizeClass = window.innerWidth / window.innerHeight > portraitAr ? 'w100' : 'h100'

				jQuery('#intro-region .mediawrap').removeClass('w100 h100').addClass(portraitSizeClass)
			} else {
				var portraitAr = $portrait.data('w') / $portrait.data('h')
				var portraitSizeClass = window.innerWidth / window.innerHeight > portraitAr ? 'w100' : 'h100'

				jQuery('#intro-region .mediawrap').removeClass('w100 h100').addClass(portraitSizeClass)
			}
		}

		if ($landscape.length > 0 && Utility.orientation === 'landscape') {
			var landscapeAr = $landscape.data('w') / $landscape.data('h')
			var landscapeSizeClass = window.innerWidth / window.innerHeight > landscapeAr ? 'w100' : 'h100'

			jQuery('#intro-region .mediawrap').removeClass('w100 h100').addClass(landscapeSizeClass)
		}
	},
}

export default intromedia_controller
